module.exports = __webpack_public_path__ + "static/img/f3-16.1ff32bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/f3-16.png
// module id = VjSd
// module chunks = 1